import React, { useContext } from 'react'
import { CusContext } from 'src/App'
import useStoreInContext from 'src/hooks/useStoreInContext'
import SvgIcon from './common/SvgIcon'
import styles from './index.less'
import type { NODE_TYPE } from 'src/utils/basic'

interface WrapperImageProps {
  children?: React.ReactNode
  node: NODE_TYPE
  handleDragStart: (
    event: React.DragEvent<HTMLDivElement>,
    node: NODE_TYPE,
  ) => void
}

function WrapperImage({ node, handleDragStart }: WrapperImageProps) {
  // const currentNode = NODES[nodeKey as keyof typeof NODES]

  // const { connectionHandleId, connectionHandleType } = useStore((s) => {
  //   return {
  //     connectionHandleId: s.connectionHandleId ? s.connectionHandleId : undefined,
  //     connectionHandleType: s.connectionHandleType,
  //   }
  // })

  const isLock = useStoreInContext(state => state.isLock)

  const { hasInputNode, hasOutputNode, handleAddNode } = useContext(CusContext)

  const draggable = () => {
    if (isLock)
      return false
    if (node.value === 'input') {
      return !hasInputNode
    }
    if (node.value === 'output') {
      return !hasOutputNode
    }
    return true
  }

  const isDraggable = draggable()

  const handleClickItem = () => {
    if (isDraggable) {
      handleAddNode(node.value)
    }
  }

  return (
    <div
      draggable={isDraggable}
      onDragStart={(event: React.DragEvent<HTMLDivElement>) =>
        handleDragStart(event, node)}
      className={`${!isDraggable ? styles.notDraggable : ''} ${
        styles.wrapperImage
      }`}
      title={node.caption}
      onClick={() => handleClickItem()}
    >
      {/* <span
        style={{
          fontSize: 14,
        }}
        className={`${iconcoolStyles.iconcool} ${
          iconcoolStyles[ICONS_MAP[node.value]]
        } ${styles.content}`}
      >
        {node.name}
      </span> */}
      <span className={styles.content}>
        <SvgIcon type={node.value} />
        <span className={styles.name} title={node.name}>
          {node.name}
        </span>
      </span>
    </div>
  )
}

export default React.memo(WrapperImage)
